<template>
  <div id="snackbarcenter" class="SnackbarCenterWrapper noScrollbar">
    <transition-group
      v-if="queue"
      name="elem"
      tag="div"
      class="transitionWrapper"
    >
      <snackbar v-for="elem in queue" :key="elem.id" :config="elem" />
    </transition-group>
  </div>
</template>

<script>
import snackbar from "~/components/shared/snackbar"

import { mapState } from "vuex"

export default {
  components: {
    snackbar,
  },
  computed: {
    ...mapState({
      queue: (state) => state.snackbar.queue,
    }),
  },
  watch: {
    "queue.length": function () {
      const target = window.document.getElementById("snackbarcenter")

      if (target !== null) {
        target.scrollTo({
          top: target.scrollHeight,
          left: 0,
          behavior: "smooth",
        })
      }
    },
  },
}
</script>

<style scoped>
.SnackbarCenterWrapper {
  position: fixed;
  z-index: 1000001;
  max-height: 100vh;
  overflow-y: scroll;
  bottom: 0px;
  left: 0px;
}

.transitionWrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.elem-enter-active,
.elem-leave-active {
  transition: opacity 0.6s var(--trans-standart);
}

.elem-enter,
.elem-leave-to {
  opacity: 0;
}
</style>
